import { css } from '@emotion/css';

const buttonWrapper = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: var(--spacings-4) 0;
`;

const button = css`
  padding: var(--spacings-1) var(--spacings-4) !important;
  border-radius: var(--radius-2) !important;
  color: var(--colors-primary-500) !important;
  border-color: var(--colors-primary-500) !important;

  svg {
    margin-left: var(--spacings-1);
    width: 1rem;
    height: 1rem;
  }

  &:disabled {
    color: var(--colors-neutral-500) !important;
    border-color: var(--colors-neutral-500) !important;
  }
`;

const DownloadButtonStyles = {
  buttonWrapper,
  button,
};

export default DownloadButtonStyles;
